/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react'
import style from "./header.module.scss"
import { useReactRouter } from 'hooks/useReactRouter'
import ModelFn from 'components/model/ModelFn'
import ReactDOM from 'react-dom'
import Icon from 'components/Icon/Icon'
import { getWindowWidth } from 'utils/dom'
import { clearLoginInfo } from 'service/sign'
import { RouterPaths } from 'utils/constant'
import { isMobile } from 'utils/utils'

interface Props {
  show: boolean
  showModify: () => any
  closeMenu: (arg1: boolean) => any
}

function Menu({ show, showModify, closeMenu }: Props) {
  const { history } = useReactRouter()
  const width = getWindowWidth()

  if (!show) {
    return null
  }

  function clickMenu(type: string, value?) {
    if (type === 'path') {
      history.push(value)
    } else if (type === 'modify') {
      showModify()
    } else if (type === 'signout') {
      ModelFn.confirm({ text: '确定注销登录？', onConfirm: signOut })
    }

    closeMenu(false)
  }

  function signOut() {
    clearLoginInfo()
    isMobile() ? history.push(RouterPaths['signin-phone']) : history.push(RouterPaths['signin-qr'])
  }

  if (width <= 767) {
    return <MenuMobile show={show} clickMenu={clickMenu} />
  }

  return (
    <div className={style.menu}>
      <div
        onClick={(e) => clickMenu('path', RouterPaths.userInfo)}
        className={style.item}>
        账号信息
      </div>
      <div
        onClick={(e) => clickMenu('path', RouterPaths.records)}
        className={style.item}>
        购买记录
      </div>
      <div
        onClick={(e) => clickMenu('path', RouterPaths.settings)}
        className={style.item}>
        安全设置
      </div>
      <div
        onClick={(e) => clickMenu('path', RouterPaths.equipment)}
        className={style.item}>
        登录设备
      </div>
      {
        JSON.parse(localStorage.UserInfo).is_cd_key_partner ?       
          <div
            onClick={(e) => clickMenu('path', RouterPaths.camilo)}
            className={style.item}>卡密信息
          </div>
          : null
      }

      <div
        onClick={(e) => clickMenu('signout')}
        className={style.item}>
        注销登录
      </div>
    </div>
  )
}

interface MProps {
  show: boolean
  clickMenu: (arg1: string, arg2?) => any
}

function MenuMobile({ clickMenu, show }: MProps) {
  if (!show) {
    return null
  }

  return ReactDOM.createPortal(
    <div className={style['menu-mobile']}>
      <Icon
        onClick={() => clickMenu('none')}
        icon="iconicon_exit_"
        className={style.close}
      />
      <div
        onClick={(e) => clickMenu('path', RouterPaths.userInfo)}
        className={style.item}>
        账号信息
      </div>
      <div
        onClick={(e) => clickMenu('path', RouterPaths.records)}
        className={style.item}>
        购买记录
      </div>
      <div
        onClick={(e) => clickMenu('path', RouterPaths.settings)}
        className={style.item}>
        安全设置
      </div>
      <div
        onClick={(e) => clickMenu('path', RouterPaths.equipment)}
        className={style.item}>
        登录设备
      </div>
      {
        JSON.parse(localStorage.UserInfo).is_cd_key_partner ?       
          <div
            onClick={(e) => clickMenu('path', RouterPaths.camilo)}
            className={style.item}>卡密信息
          </div>
          : null
      }
      <div
        onClick={(e) => clickMenu('signout')}
        className={style.item}>
        注销登录
      </div>
    </div>,
    document.querySelector('#menu-mobile') as Element
  )
}

export default Menu
